'use es6';

import uniqueId from 'transmute/uniqueId';
import RecordFactory from '../RecordFactory';
import { AdWordsStatusMap, AppStoreEnum, Networks } from '../../lib/Constants';
export default RecordFactory({
  id: null,
  adType: null,
  accountId: null,
  campaignId: null,
  network: Networks.ADWORDS,
  adGroupId: null,
  status: AdWordsStatusMap.ENABLED,
  displayUrl: '',
  finalUrl: '',
  description1: '',
  description2: '',
  headline: '',
  appId: '',
  // id number for iOS, package name string for android
  appStore: AppStoreEnum.GOOGLE_PLAY,
  mobile: null,
  trackingUrlTemplate: null,

  isValidForSave() {
    return this.headline && this.description1 && this.description2 && this.appId;
  },

  getSearchString() {
    return `${this.headline}${this.displayUrl}${this.finalUrl}${this.description1}${this.description2}`.toLowerCase();
  },

  previousState: null
}, () => {
  return {
    id: `${uniqueId() * -1}`
  };
});